import { Button as CButton } from "../account/misc/Button";

interface CancelRegistrationLinkProps {
  onCancel: () => void;
}

export default function CancelRegistrationLink({ onCancel }: CancelRegistrationLinkProps) {
  return (
    <h6>
      Wrong account?{" "}
      <CButton type={"LinkPrimary"} className={"sign-in-link"} onClick={onCancel}>
        Cancel and sign in with a different email
      </CButton>
    </h6>
  );
}
